/* eslint-disable */
import { groupBy } from 'lodash';
import { Box, Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import TabPanel from 'components/TabPanel/TabPanel';
import { existTabItems } from 'pages/globals/global';
import ListViewService from './ListView-ServiceLevel';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ComptrollerPageHeader from 'components/header/ComptrollerPageHeader';
import { useGetServiceLevelListMutation } from 'store/features/comptroller/comptrollerApi';
import ServiceLevelAgreementCreateModal from './ServiceLevelAggrementCreateModal';

function Index() {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();

	const [SLATable, setSLATable] = useState([]);
	const [tabsItem, setTabsItem] = useState([]);
	const [selectedTab, setSelectedTab] = useState(0);
	const [reloadTable, setReloadTable] = useState(false);
	const [openCreateModal, setOpenCreateModal] = useState(false);
	const [activeCreateButton, setActiveCreateButton] = useState(true);

	const [GetServiceLevelList, { data: getServiceLevelList, isSuccess, isLoading }] = useGetServiceLevelListMutation();

	useEffect(() => {
		GetServiceLevelList({});
	}, [reloadTable]);

	const selectTabHandler = (event, newValue) => {
		setSelectedTab(newValue);

		const tabName = tabsItem?.[newValue]?.label?.toLowerCase()?.replaceAll('-', '');

		navigate(`/comptroller/service-level-agreement?tab=${tabName}`);
	};

	useEffect(() => {
		setActiveCreateButton(isLoading);
	}, [isLoading]);

	useEffect(() => {
		if (getServiceLevelList?.lynSLADefinitions) {
			const arr1 = groupBy(getServiceLevelList?.lynSLADefinitions, 'activationStatus');

			arr1['All'] = getServiceLevelList?.lynSLADefinitions ?? [];

			const arr2 = Object.keys(arr1);

			const newTabs = existTabItems?.filter((item) => arr2.includes(item.data));

			setTabsItem(newTabs);
			setSLATable(arr1);
		}
	}, [isSuccess]);

	useEffect(() => {
		const activeTab = searchParams.get('tab');

		if (tabsItem?.length > 0 && activeTab) {
			const index = tabsItem?.findIndex((item) => item?.label?.toLowerCase()?.replaceAll('-', '') === activeTab);

			if (index > -1) setSelectedTab(index);
			else setSelectedTab(0);
		}
	}, [tabsItem]);

	return (
		<Grid container rowSpacing={4.5} columnSpacing={2.75}>
			<Grid item xs={12}>
				<ComptrollerPageHeader
					tabsItem={tabsItem}
					selectedTab={selectedTab}
					title="Service Level Agreement"
					selectTabHandler={selectTabHandler}
					activeCreateButton={activeCreateButton}
					navigate={() =>
						// navigate('/comptroller/service-level-agreement/create')

						setOpenCreateModal(true)
					}
				/>

				<Box sx={{ borderBottom: 1, borderColor: 'divider', width: '100%' }}>
					{tabsItem?.map((item, index) => (
						<TabPanel key={index} value={selectedTab} index={index} sx={{ height: 'calc(100% - 38px)' }}>
							<Box sx={{ background: '#fff', padding: '20px', borderRadius: '4px' }}>
								<ListViewService
									navigate={navigate}
									isLoading={isLoading}
									setSelectedTab={setSelectedTab}
									setReloadTable={setReloadTable}
									tableData={SLATable[item?.data]}
								/>
							</Box>
						</TabPanel>
					))}
				</Box>
			</Grid>

			{openCreateModal && <ServiceLevelAgreementCreateModal setReloadTable={setReloadTable} setOpenCreateModal={setOpenCreateModal} />}
		</Grid>
	);
}

export default Index;
